import { PostEditorErrorKeys } from '../../../../models/validator-props';
import { PostEditorErrors, PostEditorPostErrors } from '../../../../models/post-editor';
import { isArray } from 'lodash';

const composeMessage = (
  error: PostEditorPostErrors | undefined,
  postId: string | null | undefined,
  variationId: number | null | undefined
): string[] => {
  if (!error) return [];
  let messages: string[] = [];
  if (isArray(error)) {
    error.forEach(e => {
      if (
        (postId !== undefined ? e.profileId === postId : true) &&
        (variationId !== undefined ? e.variationId === variationId : true) &&
        e.message
      ) {
        if (!messages.includes(e.message)) {
          messages = [...messages, e.message];
        }
      }
    });
  } else if (
    error &&
    error.message &&
    (postId !== undefined ? error.profileId === postId : true) &&
    (variationId !== undefined ? error.variationId === variationId : true)
  ) {
    if (!messages.includes(error.message)) {
      messages = [...messages, error.message];
    }
  }
  return messages;
};

export const getErrorMessages = (
  errors: PostEditorErrors,
  postId: string | null | undefined,
  variationId: number | null | undefined,
  keys: PostEditorErrorKeys | PostEditorErrorKeys[] | 'all'
): string[] => {
  let messages: string[] = [];
  if (isArray(keys) || keys === 'all') {
    const selectedKeys = keys === 'all' ? (Object.keys(errors) as PostEditorErrorKeys[]) : keys;
    selectedKeys.forEach(key => {
      if (errors[key]) {
        const error = errors[key];
        const newMessages = composeMessage(error, postId, variationId);
        messages = [...messages, ...newMessages];
      }
    });
  } else if (errors[keys]) {
    const error = errors[keys];
    const newMessages = composeMessage(error, postId, variationId);
    messages = [...messages, ...newMessages];
    // if (isArray(error)) {
    //   error.forEach(e => {
    //     if (e.postIndex === postIndex && e.variationIndex === variationIndex && e.message) {
    //       messages = [...messages, e.message];
    //     }
    //   });
    // } else if (error && error.message && error.variationIndex === variationIndex && error.postIndex === postIndex) {
    //   messages = [...messages, error.message];
    // }
  }
  return messages;
};
